import { CopyToClipboard, DownloadTextFile } from "../../Shared/Utils/fileHelpers";
import { buildExportReportModel } from "./exportReportModel";
import { buildTextExport } from "./exportText";

export const getSafeData = (data, language, fallbackLanguage = "en") => {
  if (!data) {
    return [];
  }

  const lang = language && data[language] ? language : fallbackLanguage;
  return data[lang] || data[fallbackLanguage] || [];
};

export { DownloadTextFile };

export const CopyReportToClipboard = async ({
  getAdvancedReportInfo,
  aiAnalysis,
  isRTL,
  reportApiResponse,
  reportData,
  selectedReport,
  setCopied,
  toast,
  t,
}) => {
  const reportModel = buildExportReportModel({
    aiAnalysis,
    getAdvancedReportInfo,
    isRTL,
    reportApiResponse,
    reportData,
    selectedReport,
  });
  const reportContent = buildTextExport({ model: reportModel, t });

  await CopyToClipboard(reportContent);
  setCopied(true);
  toast({
    title: t("reports.copySuccess", "تم النسخ"),
    description: t("reports.copiedToClipboard", "تم نسخ التقرير إلى الحافظة"),
    status: "success",
    duration: 2000,
    isClosable: true,
  });
  window.setTimeout(() => setCopied(false), 3000);
};
